(function () {

  'use strict';

  angular.module('eclipseApp.internet')

    .controller('internetCtrl', ['$rootScope', '$scope', 'uteModal', 'samKeyService', 'uteEndpoint', '$http', 'uteLocale', 'commonService', function ($rootScope, $scope, uteModal, samKeyService, uteEndpoint, $http, uteLocale, commonService) {

      $scope.changeInternetActions = {};

      $scope.changeInternetActions.eligible = true;

      $scope.isBtsofferEligible =  true;

      $scope.packageMode = 'browsing';

      /**
       * if customer has internet - Active / Suspended / Tentative - Not Eligible for internet offers
       * @returns {boolean}
       */
      $scope.isCustomerEligibleForBtsPromo = function () {
        if (($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent())) {
          if (commonService.customerHasInternetService && commonService.internetAccountStatus !== 'CANCELLED') {
            $scope.isBtsofferEligible =  false;
          }
          var internetAcct = _.filter($rootScope.userInfo.accounts, function (account) {
            return (account.serviceName === 'Internet/TV');
          });
          if (internetAcct && (internetAcct || []).length > 0 && internetAcct[0].status == 'TENTATIVE') {
            $scope.isBtsofferEligible = false;
          }
        }
      };

      $scope.isCustomerEligibleForBtsPromo();

      /**
       * @description by default the selected tier should be the first one in the sorted list
       * @type {number}
       */
      $scope.selectedTier = 1;

      /**
       * @description the length of the data coming from SS
       * @type {number}
       */
      $scope.totalTiers = 0;

      /**
       * @description click function to determine what tier has been selected
       * @activeTier
       */
      $scope.isSelectedTier = function (activeTier) {
        $scope.selectedTier = activeTier + 1;
      };

      $scope.offerChanged = function (tier, offer) {
        if ($.restive.isPhone()) {
          $('#package-detail').appendTo($('.package-wrapper').eq(tier - 1));
        }
        $scope.selectedSku = offer.offerId;
      };

      /**
       * @description improve handling of 60010 on change internet package flow
       */
      $scope.$on('notEligible', function () {
        $scope.changeInternetActions.eligible = false;
      });

      $scope.showAvailabilityModal = function () {

        var tier = (samKeyService.tier && samKeyService.tier.tierId) || null;
        samKeyService.showAvailabilityModal('internet', tier); //service, tier, state(targetState)

      };

      $http.get('resource/internetSystemRequirements.json')
          .success(function (response) {
            $scope.systemRequirements = response[uteLocale.language];
          });

      $scope.showTermsConditionsModal = function () {
        uteModal.open({
          templateUrl: 'modules/internet/views/internet-more-details-terms.html',
          size: 'lg',
          scope: $scope,
          controller: 'internetCtrl'
        });
      };

      $scope.showSystemRequirementsModal = function () {
        uteModal.open({
          templateUrl: 'modules/internet/views/internet-system-requirements.html',
          size: 'lg',
          scope: $scope,
          controller: 'internetCtrl'
        });
      };

      // implementation
      // uteModal.processRequest({
      //   delay: 3000,
      //   request: {
      //     method: 'GET',
      //     url: uteEndpoint('v1/slowResponse'),
      //     data: { test: 'test' },
      //     headers: {
      //       'Content-Type': 'application/x-www-form-urlencoded'
      //     }
      //   }
      // }).then(function(data){
      //   // pass / SS responds
      //   console.log(data);
      // }, function(data){
      //   // fail / cancelled
      //   console.log(data);
      // });

    }]);


})();
